export default "__VITE_ASSET__Vmy4MoOF__"